export const GET_ALL_IMAGE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_IMAGE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_IMAGE_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const CREATE_IMAGE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const CREATE_IMAGE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const CREATE_IMAGE_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const UPDATE_IMAGE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const UPDATE_IMAGE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const UPDATE_IMAGE_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const DELETE_IMAGE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const DELETE_IMAGE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const DELETE_IMAGE_SUCCESS = "GET_CUSTOMERS_SUCCESS";